import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
} from 'reactstrap';
import renderSelectField from '../../../shared/components/form/Select';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import simplifyCurriculumName from '../../../helpers/stringFormat';
import validate from './validate';

class InscriptionForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onChangeStudent: PropTypes.func.isRequired,
    onInscriptionChanges: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    students: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    subjects: PropTypes.arrayOf(PropTypes.shape({})),
    student: PropTypes.shape({}),
  }

  static defaultProps = {
    submitting: false,
    student: {},
    subjects: [],
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      submitting,
      handleSubmit,
      onBack,
      students,
      subjects = [],
      onChangeStudent,
      onInscriptionChanges,
    } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <Form className="form" onSubmit={handleSubmit}>
              <div className="card__title">
                <h5 className="bold-text">Inscripci&oacute;n a materias</h5>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label required">Alumno</span>
                <div className="form__form-group-field">
                  <Field
                    name="student"
                    component={renderSelectField}
                    placeholder="Alumno"
                    autoComplete="false"
                    options={students}
                    addDefaultOption={students.length > 1}
                    onChange={v => onChangeStudent(v.value)}
                  />
                </div>
              </div>
              {
                subjects.length ? (
                  <div className="card__title" style={{ marginTop: '0' }}>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={submitting}
                      onClick={handleSubmit}
                    >Guardar
                    </button>
                    <button
                      type="submit"
                      className="btn btn-outline-secondary"
                      onClick={() => { localStorage.setItem('editProfile', false); onBack(); }}
                    >Cancelar - Volver
                    </button>
                  </div>
                ) : null
              }
              <Container className="summary-container">
                <Row dir="ltr">
                  {subjects.map(g => (
                    <Col md={6} xl={3} sm={12} key={`semester_${g.id}`}>
                      <Card>
                        <CardBody className="summary-card summary-card--primary">
                          <div className="summary-card__body checklist-card">
                            <h3 className="summary-card__title">{g.nombre}</h3>
                            <hr />
                            {g.materias.map(m => (
                              <div
                                key={`subject_${m.materiaPeriodoId}`}
                                className="summary-card__item"
                                style={{
                                  display: 'flex', rowGap: '0.4rem', columnGap: '1rem', flexWrap: 'wrap',
                                }}
                              >
                                <Field
                                  key={`subject_${m.materiaPeriodoId}`}
                                  name={`subject_${m.materiaPeriodoId}`}
                                  component={renderCheckBoxField}
                                  label={(
                                    <div key={`div-mat-${m.materiaPeriodoId}`}>
                                      <code>{m.nombre}</code>
                                      <div>
                                        <em style={{ fontSize: '14px' }}>
                                          {m.seccion}, {simplifyCurriculumName(m.malla)}
                                        </em>
                                      </div>
                                    </div>
                                  )}
                                  value={m.inscripto ? 'checked' : ''}
                                  style={{ paddingRight: '0' }}
                                  labelStyle={{ paddingTop: '0', marginBottom: '0' }}
                                  defaultChecked={m.inscripto}
                                  onChange={v => onInscriptionChanges(m.materiaPeriodoId, v)}
                                />

                                <div style={{ marginLeft: '20px' }}>
                                  {m.horarios.map(({
                                    id,
                                    dia,
                                    horaInicio,
                                    horaFin,
                                  }) => (
                                    <div
                                      key={`hm_${id}-${m.materiaPeriodoId}`}
                                      style={{ display: 'flex', fontSize: '0.9rem' }}
                                    >
                                      <span>{dia.label.substring(0, 3)}.:{horaInicio}-{horaFin}</span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Container>

            </Form>
            <div className="card__title">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={() => { localStorage.setItem('editProfile', false); onBack(); }}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxInscriptionForm = reduxForm({
  form: 'InscriptionForm',
  validate,
  enableReinitialize: true,
})(InscriptionForm);

export default setPropsAsInitialValues(ReduxInscriptionForm);
